import { useId } from 'react'
import { useTranslation } from 'react-i18next'
import { Switch } from '@/components/ui/switch'
import type { EntityDescriptor, SubjectEntity } from '@/services/api/structuredIngest'
import { withPhoneFormat } from './recipe-edits'

export function PhoneFormatToggle<T extends SubjectEntity | EntityDescriptor>({
  item,
  onChange,
}: {
  item: T
  onChange: (next: T) => void
}) {
  const { t } = useTranslation()
  const id = useId()
  return (
    <div className="flex flex-col gap-1">
      <label htmlFor={id} className="flex items-center gap-2 text-xs">
        <Switch
          id={id}
          checked={item.identity_rule?.trim().toLowerCase() === 'e164'}
          onCheckedChange={checked => onChange(withPhoneFormat(item, checked))}
        />
        {t('tableMapping.identity.phoneFormat')}
      </label>
      <p className="text-xs text-muted-foreground">
        {t('tableMapping.identity.phoneFormatDetail')}
      </p>
    </div>
  )
}
